import { render, staticRenderFns } from "./MarkingsList.vue?vue&type=template&id=15a38c1b&scoped=true"
import script from "./MarkingsList.vue?vue&type=script&lang=js"
export * from "./MarkingsList.vue?vue&type=script&lang=js"
import style0 from "./MarkingsList.vue?vue&type=style&index=0&id=15a38c1b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a38c1b",
  null
  
)

export default component.exports